
export default function printHtml(html) {
  let style = getStyle();
  let container = getContainer(html);
  document.body.appendChild(style);
  document.body.appendChild(container);
  getLoadPromise(container).then(() => {
    window.print();
    document.body.removeChild(style);
    document.body.removeChild(container);
  });
}

// 设置打印样式
function getStyle() {
  let styleContent = `
    * {
      -webkit-print-color-adjust: exact !important; /* Chrome/Safari */
      print-color-adjust: exact !important;          /* 标准属性 */
    }
    #print-container {
      display: none;
    }
    @media print {
      body > :not(.print-container) {
        display: none;
      }
      html,
      body {
        margin: 0 0.2cm;
        display: block !important;
        height:auto;
      }
      #print-container {
        display: block;
      }
      .problemDesInfo {
        height: auto !important;
        overflow: "visible"
      }
      .approvalRecord .block {
        max-height: none !important;
      }
      .el-table .el-table__header colgroup col,
      .el-table .el-table__body colgroup col {
        display: none
      }
      .el-table .el-table__header,
      .el-table .el-table__body {
        width: 100% !important;
        table-layout: fixed;
      }
      .el-table .el-table__cell {
        word-wrap: break-word !important;
        white-space: normal !important;
      }
      .el-table .el-table__cell .cell {
        width: auto !important;
        word-wrap: break-word !important;
        white-space: normal !important;
      }
      .el-table .el-table__cell:first-child,
      .el-table .el-table__header .el-table__cell:first-child {
        width: 50px !important
      }
      @page {
        margin: 0.25cm;
      }
  }`;
  let style = document.createElement("style");
  style.innerHTML = styleContent;
  return style;
}

// 清空打印内容
function cleanPrint() {
  let div = document.getElementById("print-container");
  if (div) {
    document.querySelector("body").removeChild(div);
  }
}

// 新建DOM，将需要打印的内容填充到DOM
function getContainer(html) {
  cleanPrint();
  let container = document.createElement("div");
  container.setAttribute("id", "print-container");
  container.innerHTML = html;
  return container;
}

// 图片完全加载后再调用打印方法
function getLoadPromise(dom) {
  let imgs = dom.querySelectorAll("img");
  imgs = [].slice.call(imgs);
  if (imgs.length === 0) {
    return Promise.resolve();
  }

  let finishedCount = 0;
  return new Promise((resolve) => {
    function check() {
      finishedCount++;
      if (finishedCount === imgs.length) {
        resolve();
      }
    }
    imgs.forEach((img) => {
      img.addEventListener("load", check);
      img.addEventListener("error", check);
    });
  });
}

// .el-table.postscriptTable .el-table__header-wrapper colgroup col:nth-child(2),
      // .el-table.postscriptTable .el-table__body-wrapper colgroup col:nth-child(2),
      // .el-table.postscriptTable .el-table__cell:nth-child(2),
      // .el-table.postscriptTable .el-table__cell:nth-child(2) .cell  {
  
      //   width: 240px !important;
      // }
      // .el-table.postscriptTable .el-table__header-wrapper colgroup col:nth-child(6),
      // .el-table.postscriptTable .el-table__body-wrapper colgroup col:nth-child(6),
      // .el-table.postscriptTable .el-table__cell:nth-child(6),
      // .el-table.postscriptTable .el-table__cell:nth-child(6) .cell {

      //   width: 300px !important;
      // }